module.exports = __webpack_public_path__ + "static/media/logo.cbb6d9f6.jpeg";